module.exports = __webpack_public_path__ + "img/vasl-new-year.51450b4c.jpg";